export default __webpack_public_path__ + "static/media/icon-learner.713e5a7f.svg";